import React from 'react';
import { classNames } from '../../../helpers/classnames.js';
import { Typography } from '../../Typography/Typography.js';

var TooltipContent = function (_a) {
    var title = _a.title, className = _a.className;
    return (React.createElement("div", { "data-testid": "TooltipContent", className: classNames('dsb_tooltip', className) },
        React.createElement(Typography, { variant: "caption", className: "dsb_tooltip__title" }, title)));
};

export { TooltipContent };
